<template>
	<div class="index">
		<div class="header">
			<img alt="济南市市场监督管理局" class="header-img" style="width: 100%; cursor: pointer;"
				src="@/assets/image/header.png" @click="tohome()">
			<div class="time" @click="tiao()">
				<div>{{ time }}</div>
				<div class="week">{{ day }} 星期{{ weekDatItem[0] }}</div>
			</div>
			<div class="weather" v-if="temperature">
				<span class="weather-text">{{ temperature ? temperature.weather : '' }}</span>
				<span> {{ temperature ? temperature.temperature : '' }}℃</span>
			</div>
		</div>
		<div class="content">
			<router-view></router-view>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import dayjs from "dayjs";
import { useRoute, useRouter } from 'vue-router';
const router = useRouter();
let week = ["日", "一", "二", "三", "四", "五", "六"];
let time = ref(dayjs().format("HH:mm:ss"));
let day = ref(dayjs().format("YYYY/MM/DD"));
let weekday = dayjs().format("d");
const weekDatItem = ref(week.filter((item, index) => index == weekday));

const temperature = JSON.parse(sessionStorage.getItem('temperature'))


const formData = () => {
	time.value = dayjs().format("HH:mm:ss");
};
const tohome = () => {
	router.push({ path: '/' }).then(() => {
		location.reload(); // 这将导致页面重新加载
	});
}
const tiao = () => {
	window.location.href = 'http://111.34.80.136:18081/screen/index.html';
}
setInterval(() => {
	formData();
}, 1000);
</script>

<style scoped>
.index {
	width: 100%;
	height: 100%;
}

.header {
	width: calc(100% - 32px);
	/* width: 100%; */
	box-sizing: border-box;
	padding: 0px 32px;
	margin: auto;
	height: 93px;
	position: relative;
}

.header-img {
	/* width: 100%; */
	width: calc(100% - 32px);
	height: 93px;
}

.weather {
	position: absolute;
	top: 20px;
	left: 0px;
	font-family: 'Pixel LCD7';
	font-weight: 400;
	font-size: 24px;
	color: #fff;
	line-height: 33px;
}

.weather-text {
	font-family: '';
	font-weight: 400;
	font-size: 16px;
	color: #FFFFFF;
	line-height: 18px;
}

.time {
	position: absolute;
	top: 0px;
	right: 0px;
	font-family: 'Pixel LCD7';
	font-weight: 400;
	font-size: 24px;
	color: #fff;
	line-height: 33px;
}

.week {
	font-size: 18px;
	color: #00E8E8;
	line-height: 20px;
	padding-top: 10px;
}

.content {
	width: 100%;
	height: calc(100% - 93px);
	box-sizing: border-box;
	padding: 12px 18px 18px 18px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
